import { defineComponent, getCurrentInstance } from "vue";
import i18n from "@/lang";
export default defineComponent({
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var config = [
            {
                id: 0,
                title: i18n.t("playTurbo.navbarTool.tool.playable.template"),
                pathName: "creative-template.lib"
            },
            {
                id: 1,
                title: i18n.t("playTurbo.navbarTool.tool.playable.editor"),
                pathName: "my-project.playable",
                query: {
                    project_type: "playsmart"
                }
            },
            {
                id: 2,
                title: i18n.t("playTurbo.navbarTool.tool.video.editor"),
                pathName: "my-project.video.normal"
            },
            {
                id: 3,
                title: i18n.t("playTurbo.navbarTool.tool.customized.creative"),
                pathName: "creative-service.playable.list"
            }, 
        ];
        var handleMenuItem = function(pathName, query) {
            root.$router.push({
                name: pathName,
                query: query
            });
        };
        return {
            config: config,
            handleMenuItem: handleMenuItem
        };
    }
});
